import { useToggle } from "../../../hooks/useToggle";
import { sliceShownOtherItems } from "../utils/sliceShownOtherItems";
import { ConfigOptions } from "../types";

export const useShownOtherItems = <T extends unknown[]>(options: ConfigOptions) => {
  const [showMore, onShowMore] = useToggle();
  const { shownItems } = options;

  return {
    sliceItems: <I extends T>(items: I) => sliceShownOtherItems(items, options, showMore) as I,
    checkIsSliced: <I extends T>(items: I) => !!shownItems && items?.length > shownItems,
    onShowMore,
    showMore,
  };
};
